<template>
  <div
    id="app"
    :class="[
      $padFalg == 'other' ? '' : 'ipad ' + $padFalg,
      applets,
      $store.state.gameType == 1 ? 'lzg' : '',
      $store.state.gameType == 2 ? 'gl' : '',
      $store.state.gameType == 3 ? 'dqss' : '',
      $store.state.gameType == 4 ? 'lhlr' : '',
      $store.state.gameType == 5 ? 'gl rox' : '',
      $store.state.wxProgram ? 'xcx' : ''
    ]"
  >
    <index id="index" v-if="$store.state.status != 2"></index>
    <banned v-if="$store.state.status == 2"></banned>
    <login ref="login" v-show="$store.state.loginShow"></login>
  </div>
</template>

<script>
import index from './components/index.vue';
import banned from './components/banned.vue';
import login from './components/login.vue';
// import user from "./utils/questionConfig";
import get from '@/api/get';
import qs from 'qs';
import Cookies from 'js-cookie';
import { Dialog } from 'vant';
export default {
  name: 'App',
  components: {
    index,
    banned,
    login
  },
  data() {
    return {
      applets: ''
    };
  },
  watch: {
    '$store.state.loginShow': {
      handler: function (newVal, oldVal) {
        if (this.$store.state.loginShow) {
          if (
            this.$store.state.isXcx &&
            location.href.indexOf('login=no') == -1
          ) {
            // this.$refs.login.getTip(1, null);//小程序双账号登录冲突
          } else {
            this.$refs.login.getTip(0, 0);
          }
        }
      }
    },
    '$store.state.bindCodeShow': {
      handler: function (newVal, oldVal) {
        if (this.$store.state.bindCodeShow) {
          localStorage.setItem('bindCodeShow', true);
        } else {
          localStorage.setItem('bindCodeShow', false);
        }
      }
    },
    '$store.state.bindIconShow': {
      handler: function (newVal, oldVal) {
        if (this.$store.state.bindIconShow) {
          localStorage.setItem('bindIconShow', true);
        } else {
          localStorage.setItem('bindIconShow', false);
        }
      }
    }
  },
  created() {
    if (!localStorage.getItem('uuid')) {
      localStorage.setItem('uuid', this.getUuid());
    }
    this.$store.commit('changeGameType');
    // 是否显示视频入口 (8/10 第七史诗全部端开放，安卓根据 gameClientVersionCode 判断 是否显示； ios和pc直接显示)
    if (this.$store.state.gameType == 5 || this.$store.state.gameType == 2) {
      if (!location.href.includes('postPage')&&!location.href.includes('wikiPage')&&!location.href.includes('painting')&&!location.href.includes('topicPage')) {
        this.$router.push({ name: 'guidePage' });
      }
    }
    let system = this.$store.state.system;
    let isVideoShow = false;
    if (this.$store.state.gameType === 3 || this.$store.state.gameType === 2) {
      if (system === 'android') {
        if (
          location.href.indexOf('gameClientVersionCode=') != -1 ||
          !this.$store.state.isInGame
        ) {
          isVideoShow = true;
        }
      } else {
        isVideoShow = true;
      }
      this.$store.commit('setUpVideoShow', isVideoShow);
    }

    switch (this.$store.state.gameType) {
      case 1:
        document.title = '龙之国物语-官方社区';
        this.addMeta('keywords', '');
        this.addMeta('description', '');
        break;
      case 2:
        document
          .querySelector('link[rel="icon"]')
          .setAttribute(
            'href',
            'https://media.tentree-games.com/media/pictures/community/img/gl/favicon.png'
          );
        this.addMeta('baidu-site-verification', 'codeva-eNYn4bBtz3');
        this.addMeta(
          'keywords',
          '鋼嵐社区,鋼嵐,鋼嵐MA,鋼嵐Mecharashi,Mecharashi,战棋,黑杰克,紫龙,紫龙游戏,机兵,机甲,机师,机甲游戏,鋼嵐攻略,鋼嵐视频'
        );
        this.addMeta(
          'description',
          '鋼嵐社区是游戏《鋼嵐》官方指定社区,在这里集合了游戏资讯、社交聊天、实用工具、攻略干货、游戏福利等全方位内容。参与社区专属活动，有机会获取各种游戏福利。请加入我们！建设更好的鋼嵐社区！'
        );
        document.title = '鋼嵐-官方社区';
        break;
      case 3:
        document
          .querySelector('link[rel="icon"]')
          .setAttribute(
            'href',
            'https://media.zlongame.com/media/pictures/cn/community/img/dqss/favicon.png'
          );
        this.addMeta(
          'keywords',
          '第七史诗社区,e7,e7社区,rta,第七史诗,epic seven,epic7,魔灵like,wiki,紫龙,紫龙游戏,魔灵召唤,rpg游戏,黑色幸存者,双马尾,第七史诗攻略,第七史诗视频,二次元游戏,二次元,二次元美少女,二次元动作手游,骑士团,圣约,卡牌游戏,欧勒毕斯,挑战深渊,韩国游戏,日式冒险卡牌,日式二次元卡牌,好游戏'
        );
        this.addMeta(
          'description',
          '第七史诗社区是游戏《第七史诗》官方指定社区,在这里集合了游戏资讯、社交聊天、实用工具、攻略干货、游戏福利等全方位内容。参与社区专属活动，有机会获取各种游戏福利。请加入我们！建设更好的第七史诗社区！'
        );
        document.title = '第七史诗手游-官方社区';
        break;
      case 4:
        document.title = '龙魂旅人-官方社区';
        document.querySelector('link[rel="icon"]').setAttribute('href', '');
        this.addMeta('keywords', '');
        this.addMeta('description', '');
        break;
      default:
        break;
    }
    this.init();
    Cookies.set(
      `_pd_ckey`,
      this.$store.state.gameAppkeyArr[this.$store.state.gameType],
      {
        expires: 14,
        path: '/',
        domain: '.tentree-games.com'
      }
    );
    //解决vuex状态管理刷新token清空
    // if (sessionStorage.getItem('userObj')) {
    //   // this.$store.commit(
    //   //   'setUserInfo',
    //   //   JSON.parse(sessionStorage.getItem('userObj'))
    //   // );
    // }
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem(
        'userObj',
        JSON.stringify(this.$store.state.userObj)
      );
    });
  },
  mounted() {
    this.getWxProgram();
  },
  methods: {
    addMeta(name, content) {
      const meta = document.createElement('meta');
      meta.name = name;
      meta.content = content;
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    getWxProgram() {
      // 获取当前环境
      const ua = navigator.userAgent.toLowerCase();
      if (
        ua.match(/MicroMessenger/i) &&
        ua.match(/MicroMessenger/i)[0] == 'micromessenger'
      ) {
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            // 在小程序环境内
            this.$store.commit('changeWxProgram', true);
            this.$store.commit('changeGameType');
            switch (this.$store.state.gameType) {
              case 1:
                document.title = '龙之国物语社区';
                break;
              case 2:
                document.title = '鋼嵐社区';
                break;
              case 3:
                document.title = '第七史诗手游社区';
                break;
              case 4:
                document.title = '龙魂旅人社区';
                break;
              default:
                break;
            }
          } else {
            // 不在小程序内
            this.$store.commit('changeWxProgram', false);
          }
        });
      } else {
        // 不在微信浏览器内
        this.$store.commit('changeWxProgram', false);
      }
    },
    getUuid() {
      if (typeof crypto === 'object') {
        if (typeof crypto.randomUUID === 'function') {
          return crypto.randomUUID();
        }
        if (
          typeof crypto.getRandomValues === 'function' &&
          typeof Uint8Array === 'function'
        ) {
          const callback = (c) => {
            const num = Number(c);
            return (
              num ^
              (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (num / 4)))
            ).toString(16);
          };
          return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(
            /[018]/g,
            callback
          );
        }
      }
      let timestamp = new Date().getTime();
      let perforNow =
        (typeof performance !== 'undefined' &&
          performance.now &&
          performance.now() * 1000) ||
        0;
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        let random = Math.random() * 16;
        if (timestamp > 0) {
          random = (timestamp + random) % 16 | 0;
          timestamp = Math.floor(timestamp / 16);
        } else {
          random = (perforNow + random) % 16 | 0;
          perforNow = Math.floor(perforNow / 16);
        }
        return (c === 'x' ? random : (random & 0x3) | 0x8).toString(16);
      });
    },
    webUserLogin(params) {
      get.webLogin(qs.stringify(params)).then((res) => {
        this.$refs.login.loading = false;
        if (res.data.data.length == 0) {
          this.$store.commit('changeLoginShow', true);
          this.$refs.login.getTip(1, null);
        } else if (res.data.data.length == 1) {
          let objToken = JSON.parse(sessionStorage.getItem('userObj')) || {};
          objToken.memberId = res.data.data[0].memberId;
          objToken.token = res.data.data[0].token;
          objToken.loginStatus = true;
          // alert(objToken.token);
          sessionStorage.setItem('userObj', JSON.stringify(objToken));
          this.$store.commit('setUserInfo', objToken);
          this.$store.commit(
            'changeToken',
            Cookies.get(
              `_pd_auth_${
                this.$store.state.gameAppkeyArr[this.$store.state.gameType]
              }`
            )
          ); //登录后替换token
          this.$store.commit('changeLoginStatus', 1);
          this.$store.commit('changeLoginShow', false);
          // if (res.data.data[0].bindFlag == 1) {  //后端登录未绑定社区帐号存在bug，摈弃之前的逻辑，从cookie拿状态
          //   this.$store.commit('changeBindCodeShow', true);
          // } else {
          //   this.$store.commit('changeBindCodeShow', false);
          // }
          if (Cookies.get('_pd_bf')) {
            let bindDataArr = Cookies.get('_pd_bf').split('##')[0].split('#');
            //['10123761417', '1', '0'] memberId|bindflag|bindphoneview
            if (bindDataArr[1] == 1) {
              this.$store.commit('changeBindCodeShow', true);
            } else {
              this.$store.commit('changeBindCodeShow', false);
            }
            if (bindDataArr[2] == 1) {
              this.$store.commit('changeBindPhoneShow', true);
            } else {
              this.$store.commit('changeBindPhoneShow', false);
            }
          }
        } else {
          //两个账号
          this.$refs.login.$set(this.$refs.login.userArr, 0, res.data.data[0]);
          this.$refs.login.$set(this.$refs.login.userArr, 1, res.data.data[1]);
          this.$refs.login.getTip(2, null);
          if (this.$store.state.isXcx) {
            //小程序载入时loginshow为false，需要手动转true（网页版自动为true）
            this.$store.commit('changeXcxLoginChoose', true); //避开调取小程序登录
            this.$store.commit('changeLoginShow', true);
          }
        }
      });
    },
    getRamNumber() {
      var result = '';
      for (var i = 0; i < 40; i++) {
        result += Math.floor(Math.random() * 16).toString(16); //获取0-15并通过toString转16进制
      }
      return result;
    },
    init() {
      let _this = this;
      this.userInfo = window.user;
      let pageName = window.location.href
        .split('#')[1]
        .split('/')[1]
        .split('?')[0];
      //社区加载
      if (window.user.login) {
        //小程序端
        this.$store.commit('changeLoginStatus', 0);
        this.getUserInfo(this.userInfo);
        if (window.user.login == 'no') {
          this.$store.commit('changeLoginShow', true);
        }
      } else {
        if (window.user.roleid) {
          this.$store.commit('changeLoginStatus', 1);
        }
        if (pageName != 'postShare') this.getUserInfo(this.userInfo);
      }
    },
    getUserInfo(obj) {
      let form,
        _this = this;
      if (this.userInfo.weixcode) {
        _this.applets = 'wx';
        form = {
          appKey: obj.appkey,
          code: this.userInfo.weixcode.trim()
        };
      } else {
        form = {
          channelId: obj.channelId,
          roleName: obj.rolename,
          userId: obj.userid,
          roleId: obj.roleid,
          level: obj.rolelevel,
          serverId: obj.serverid,
          serverName: obj.servername,
          // appKey:
          //   this.$store.state.gameType == 2 ? "1705460260139" : obj.appkey,
          appKey: this.$store.state.gameAppkeyArr[this.$store.state.gameType],
          ecid: obj.ecid,
          token: obj.token,
          isRealName: 1,
          avatar: 'image',
          packageName: '',
          customparams: obj.customparams,
          gameClientVersion: obj.gameClientVersion,
          sign: obj.sign,
          t: obj.t,
          balance: obj.balance,
          vipLevel: obj.viplevel,
          device: obj.device
        };
      }
      get
        .getIndexInfo(qs.stringify(form))
        .then((res) => {
          let _data = res.data.data;
          if (res.data.data?.bindFlag == 1) {
            this.$store.commit('changeBindIconShow', true);
          } else {
            this.$store.commit('changeBindIconShow', false);
          }
          if (res.data.data?.bindPhoneView == 1) {
            this.$store.commit('changeBindPhoneShow', true);
          }
          if (this.userInfo.weixcode && res.data.code == 2900) {
            _this.$store.commit('changeOpenId', _data);
            if (this.$route.path == '/topicPage/')
              this.$router.push('/xcxlogin');
          } else {
            if (_data.openId) {
              _this.$store.commit('changeOpenId', _data.openId);
            }
            if (res.data.code == 1013) {
              _this.$store.commit('changeBannedText', res.data.data);
              _this.$store.commit('changeStatus', 2);
            } else {
              _this.$store.commit('setUserInfo', _data);
              if (
                !sessionStorage.getItem('userObj') &&
                // this.$store.state.gameType == 2 &&
                !this.$store.state.isInGame
              ) {
                //鋼嵐缓存信息
                sessionStorage.setItem(
                  'userObj',
                  JSON.stringify(this.$store.state.userObj)
                );
              }
              // if (!window.user.roleid) {
              //非游戏内进入
              let cook_auth = `_pd_auth_${
                this.$store.state.gameAppkeyArr[this.$store.state.gameType]
              }`; //登陆cookie
              if (Cookies.get(cook_auth)) {
                this.$store.commit('changeLoginStatus', 1);
                this.$store.commit('changeToken', Cookies.get(cook_auth));
                if (Cookies.get('_pd_bf')) {
                  let bindDataArr = Cookies.get('_pd_bf')
                    .split('##')[0]
                    .split('#');
                  //['10123761417', '1', '0'] memberId|bindflag|bindphoneview
                  if (bindDataArr[1] == 1) {
                    this.$store.commit('changeBindCodeShow', true);
                  } else {
                    this.$store.commit('changeBindCodeShow', false);
                  }
                  if (bindDataArr[2] == 1) {
                    this.$store.commit('changeBindPhoneShow', true);
                  } else {
                    this.$store.commit('changeBindPhoneShow', false);
                  }
                }
                // }
              }
              if (
                window.user.login &&
                window.user.login != 'no' &&
                this.$store.state.loginStatus == 0 //未登录
              ) {
                //小程序登录
                let params = {
                  opentoken: window.user.login,
                  openname: 'wechat',
                  appkey:
                    this.$store.state.gameAppkeyArr[this.$store.state.gameType],
                  // appkey:
                  //   this.$store.state.gameType == 2
                  //     ? "1705460260139"
                  //     : window.user.appkey,
                  device: `snswechat${this.getRamNumber()}`,
                  channel: 1000000002
                };
                get.xcxPhoneLogin(params).then((res) => {
                  if (res.data.status == 1) {
                    let info = res.data.data;
                    let params1 = {
                      token: info.token,
                      userId: info.userid,
                      device: `snswechat${this.getRamNumber()}`
                    };
                    this.$refs.login.loginParams = params1;
                    this.webUserLogin(params1);
                  }
                });
              }
            }
          }
          if (
            this.$route.name == 'guidePage' ||
            this.$route.name == 'dqssgameInfoMainPage'
          ) {
            //直接链接访问guidePage
            this.$eventBus.$emit('guidePageInit');
            //保证guidePage的init带有indexInfo返回的token
          }
          if (this.$route.name == 'wikiPage') {
            this.$eventBus.$emit('wikiPageInit');
          }
        })
        .catch((er) => {
          console.log('(((((((())))))))');
          console.log(er);
        });
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  /* -webkit-user-select: none; */
}

#index {
  /* width: 100%;
  max-width: 7.5rem;
  margin: auto; */
}

#app {
}
</style>
